import React from "react";
import { PROGRAMS } from "../lib/site";
import {
  Heart,
  Sparkles,
  HandCoins,
  Stethoscope,
  GraduationCap,
  Users,
} from "lucide-react";

const ICONS = {
  Heart,
  Sparkles,
  HandCoins,
  Stethoscope,
  GraduationCap,
  Users,
};

export default function Programs() {
  return (
    <section
      id="programs"
      data-testid="programs-section"
      className="relative py-20 sm:py-32 bg-[#FAF5F0]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl mb-10 sm:mb-16">
          <div className="text-xs uppercase tracking-[0.24em] font-semibold text-[#064E3B]">
            Programs
          </div>
          <div className="pill-divider mt-4" />
          <h2 className="font-serif-display text-3xl sm:text-5xl mt-6 leading-[1.1] text-[#111827] font-semibold">
            Six pillars of{" "}
            <span className="italic text-[#DC2626]">community care.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {PROGRAMS.map((p, i) => {
            const Icon = ICONS[p.icon] || Heart;
            return (
              <article
                key={p.title}
                data-testid={`program-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group rounded-3xl border border-[#E5E0DA] bg-white p-6 sm:p-8 transition-all hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-[#064E3B]/10 text-[#064E3B] group-hover:bg-[#064E3B] group-hover:text-white transition-colors">
                    <Icon size={24} strokeWidth={1.75} />
                  </div>
                  <span className="font-serif-display italic text-3xl text-[#E5E0DA] group-hover:text-[#D4AF37] transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif-display text-2xl text-[#111827] font-semibold leading-tight">
                  {p.title}
                </h3>
                <p className="mt-3 text-[#374151] leading-relaxed text-[15px]">
                  {p.desc}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
